<app-navbar></app-navbar>
<div class="container">
  <router-outlet></router-outlet>
</div>